export default function isUltraLuxTour(offer: Tours.V2Offer | Tours.V2OfferSummary): boolean {
  return offer.productType === 'ultra_lux_tour'
}
